import { useContext } from 'react';
import { CareTeamContext } from '../../store/CareTeamProvider';

export const useCareTeam: () => [
  CareTeamContext['state'],
  CareTeamContext['dispatch'],
] = () => {
  const context = useContext(CareTeamContext);
  if (!context) {
    throw new Error('Context not found' + CareTeamContext);
  }
  return [context.state, context.dispatch];
};
